// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsPopup_menu__14NJB","menuItem":"ActionsPopup_menuItem__oUmG4"};